<template>
  <input :type="type" class="form-control" :value="value" @input="handleInput" :class="classes">
</template>

<script>
export default {
  name: 'AppInput',
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: 'text'
    },
    validate: {
      type: Object,
      default: null
    }
  },
  computed: {
    classes() {
      if (!this.validate) return null
      return {
        'is-invalid': this.validate.$error && this.validate.$dirty,
        'is-valid': !this.validate.$invalid && this.validate.$dirty
      }
    }
  },
  methods: {
    handleInput(event) {
      if (this.validate) { this.validate.$touch() }
      this.$emit('input', event.target.value)
    }
  }
}
</script>